import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

// Auth service
class AuthService {
  login(username, password) {
    return axios
      .post(`${API_URL}/admin/login`, { username, password })
      .then((response) => {
        if (response.data.access_token) {
          localStorage.setItem('admin_token', response.data.access_token);
        }
        return response.data;
      });
  }

  logout() {
    localStorage.removeItem('admin_token');
  }

  register(username, email, password) {
    return axios.post(`${API_URL}/admin/register`, {
      username,
      email,
      password,
    });
  }

  getCurrentAdmin() {
    const token = this.getToken();
    return axios.get(`${API_URL}/admin/me`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  }

  getToken() {
    return localStorage.getItem('admin_token');
  }

  isAuthenticated() {
    return !!this.getToken();
  }
}

export default new AuthService();